import { render, staticRenderFns } from "./EmptyFeed.vue?vue&type=template&id=25f89bba&scoped=true&"
import script from "./EmptyFeed.vue?vue&type=script&lang=js&"
export * from "./EmptyFeed.vue?vue&type=script&lang=js&"
import style0 from "./EmptyFeed.vue?vue&type=style&index=0&id=25f89bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f89bba",
  null
  
)

export default component.exports